var map = {
	"./admin-dashboard/admin-dashboard.module": [
		"./src/app/admin-dashboard/admin-dashboard.module.ts",
		"admin-dashboard-admin-dashboard-module"
	],
	"./client-dashboard/client-dashboard.module": [
		"./src/app/client-dashboard/client-dashboard.module.ts",
		"client-dashboard-client-dashboard-module"
	],
	"./user-dashboard/user-dashboard.module": [
		"./src/app/user-dashboard/user-dashboard.module.ts",
		"user-dashboard-user-dashboard-module"
	],
	"./vendor-portal/vendor-portal.module": [
		"./src/app/vendor-portal/vendor-portal.module.ts",
		"vendor-portal-vendor-portal-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;